import React from 'react';
import Header from '.';

export const UserHeader = () => {
  return <Header headerType="logged-in" />;
};
